import React from 'react';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';

const CONTACT = {
  address: '180 Vũ Hữu, Thanh Xuân, Hà Nội',
  phone: '0888.201.881',
  phoneHref: 'tel:0888201881',
  email: 'cskh@yensaotaman.com',
  mapUrl: 'https://www.google.com/maps?q=180%20V%C5%A9%20H%E1%BB%AFu%2C%20Thanh%20Xu%C3%A2n%2C%20H%C3%A0%20N%E1%BB%99i&output=embed',
};

const ContactPage = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <main className="bg-white">
      <section className="bg-[#ECFDF5] py-14">
        <div className="container mx-auto px-4">
          <p className="text-[#10B981] font-bold uppercase tracking-widest text-sm mb-3">Liên hệ</p>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-800 mb-4">Yến Tâm An</h1>
          <p className="text-gray-600 max-w-2xl leading-relaxed">
            Ghé cửa hàng hoặc gọi trực tiếp để được tư vấn sản phẩm yến sào phù hợp cho gia đình, biếu tặng và chăm sóc sức khỏe.
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-[0.9fr_1.4fr] gap-8 items-stretch">
          <div className="space-y-4">
            <div className="border border-gray-100 rounded-lg p-5 shadow-sm">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#10B981] mt-1" />
                <div>
                  <h2 className="font-bold text-gray-800 mb-1">Địa chỉ</h2>
                  <p className="text-gray-600 leading-relaxed">{CONTACT.address}</p>
                </div>
              </div>
            </div>

            <div className="border border-gray-100 rounded-lg p-5 shadow-sm">
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#10B981] mt-1" />
                <div>
                  <h2 className="font-bold text-gray-800 mb-1">Số điện thoại</h2>
                  <a href={CONTACT.phoneHref} className="text-gray-600 hover:text-[#10B981] transition">
                    {CONTACT.phone}
                  </a>
                </div>
              </div>
            </div>

            <div className="border border-gray-100 rounded-lg p-5 shadow-sm">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#10B981] mt-1" />
                <div>
                  <h2 className="font-bold text-gray-800 mb-1">Email</h2>
                  <a href={`mailto:${CONTACT.email}`} className="text-gray-600 hover:text-[#10B981] transition">
                    {CONTACT.email}
                  </a>
                </div>
              </div>
            </div>

            <div className="border border-gray-100 rounded-lg p-5 shadow-sm">
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#10B981] mt-1" />
                <div>
                  <h2 className="font-bold text-gray-800 mb-1">Thời gian hỗ trợ</h2>
                  <p className="text-gray-600">08:00 - 21:00 hằng ngày</p>
                </div>
              </div>
            </div>
          </div>

          <div className="min-h-[420px] overflow-hidden rounded-lg border border-gray-100 shadow-sm">
            <iframe
              title="Bản đồ Yến Tâm An"
              src={CONTACT.mapUrl}
              className="w-full h-full min-h-[420px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
